// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3ihjU","header":"MessagesList_header__14Uh1","chat":"MessagesList_chat__dDQlT"};